/**
 * Welche Tipps schon bestätigt wurden und ob Tipps überhaupt gezeigt werden.
 * Liegt nur im Browser (Local Storage), zusammen mit den übrigen Einstellungen des Spiels.
 * Der Schlüssel beginnt mit „kabinett“, damit „Konto löschen“ ihn mit entfernt.
 */
import { create } from 'zustand';

const KEY = 'kabinett-tipps';
type Data = { off: boolean; seen: string[]; done: string[]; listHidden: boolean };
const EMPTY: Data = { off: false, seen: [], done: [], listHidden: false };

function load(): Data {
  try { const r = localStorage.getItem(KEY); if (r) { const p = JSON.parse(r); return { ...EMPTY, ...p, seen: Array.isArray(p.seen) ? p.seen : [], done: Array.isArray(p.done) ? p.done : [] }; } } catch { /* privater Modus o. ä. */ }
  return { ...EMPTY };
}
function save(d: Data) { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch { /* egal */ } }

type Store = Data & {
  markSeen: (id: string) => void;
  setOff: (off: boolean) => void;
  /** Alle Tipps noch einmal zeigen. */
  reset: () => void;
  markDone: (id: string) => boolean;
  hideList: () => void;
};

export const useTutorial = create<Store>((set, get) => {
  const put = (p: Partial<Data>) => { set(p); const { off, seen, done, listHidden } = get(); save({ off, seen, done, listHidden }); };
  return {
    ...load(),
    markSeen: (id) => { if (!get().seen.includes(id)) put({ seen: [...get().seen, id] }); },
    setOff: (off) => put({ off }),
    reset: () => put({ off: false, seen: [], listHidden: false }),
    markDone: (id) => { if (get().done.includes(id)) return false; put({ done: [...get().done, id] }); return true; },
    hideList: () => put({ listHidden: true }),
  };
});
